import React, {useContext, useState, useEffect} from "react";
import {AppButton, ButtonWithIcon} from "../../../styles/Butttons";
import Modal from "../../../containers/Modal";
import {Input, SelectStyled} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {FacilitatorsContext} from "../../../context/FacilitatorsProvider";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import SelectFacilitators from "../../../components/selectFacilitators/SelectFacilitators";
import {CreateCourseService} from "../../../services/CoursesServices";

export default function AddCourseModal({isOpen, close, theme, save}) {
   const {visibleList, isLoading} = useContext(FacilitatorsContext);
   const [showSuccess, setSuccess] = useState(false);
   const [currentPage, setPage] = useState(1);
   const [isSaving, setSaving] = useState(false);

   useEffect(() => {
      setSuccess(false);
      setSaving(false);
   }, [isOpen]);

   const saveCourse = e => {
      e.preventDefault();
      setSaving(true);
      const formDat = e.target.elements;

      let newDataSend = new FormData();
      newDataSend.append("idCourseType", 1);
      newDataSend.append("visible", true);
      newDataSend.append("token", localStorage.getItem("domecq_token"));
      newDataSend.append("shortDescription", formDat.shortDescription.value);
      newDataSend.append("courseName", formDat.courseName.value);
      newDataSend.append("courseCode", formDat.courseCode.value);
      newDataSend.append("longDescription", formDat.longDescription.value);
      newDataSend.append("graduateProfile", formDat.graduateProfile.value);
      newDataSend.append("startDate", formDat.startDate.value);
      newDataSend.append("endDate", formDat.endDate.value);
      newDataSend.append("linkEventBrite", formDat.linkEventBrite.value);
      newDataSend.append("pathImageDesktop", formDat.pathImageDesktop.files[0]);
      newDataSend.append("pathImageMobile", formDat.pathImageMobile.files[0]);

      CreateCourseService(newDataSend)
         .then(res => res.json())
         .then(resp => {
            const {status, data} = resp;
            if (status === "error") throw new Error("Erro");
            setSaving(false);
            console.log(resp);
         })
         .then(() => {
            setSuccess(true);
         })
         .catch(e => {
            console.log(e);
            setSaving(false);
         });
      // save(newUser);
   };

   return (
      <>
         <Modal
            isOpen={isOpen}
            close={() => {
               close();
            }}
            theme={theme}
            showSuccess={showSuccess}
            title="NUEVO CURSO ESENCIAL"
            size="big"
         >
            <>
               <DivModal>
                  <form onSubmit={saveCourse}>
                     <FormPage className={currentPage === 1 ? "isVisible" : ""}>
                        <Grid>
                           <Col large={3}>
                              <Input type="text" placeholder="Nombre del curso" name="courseName" />
                           </Col>
                           <Col large={3} offsetL={0.5}>
                              <Input type="text" placeholder="Código del certificado" name="courseCode" />
                           </Col>
                           <Col large={5} offsetL={0.5}>
                              <Grid>
                                 <Col large={5}>
                                    <Input type="date" name="startDate" />
                                 </Col>
                                 <Col large={2} />
                                 <Col large={5}>
                                    <Input type="number" name="endDate" step="any" placeholder="horas" />
                                 </Col>
                              </Grid>
                           </Col>
                        </Grid>

                        <Col className="maxMargin">
                           <Col large={12}>
                              <Grid>
                                 <Col large={5}>
                                    <Col large={12}>
                                       <Label>Perfil de egreso:</Label>
                                    </Col>
                                    <Col large={12}>
                                       <Input type="text" placeholder="Texto" name="graduateProfile" />
                                    </Col>
                                 </Col>
                                 <Col large={6} offsetL={1}>
                                    <Col large={12}>
                                       <Label>Link Eventbrite:</Label>
                                    </Col>
                                    <Col large={12}>
                                       <Input type="url" name="linkEventBrite" />
                                    </Col>
                                 </Col>
                              </Grid>
                           </Col>
                        </Col>

                        <Col large={12}>
                           <Grid>
                              <Col large={12}>
                                 <Label>Facilitadores:</Label>
                              </Col>
                              <Col large={12}>{/* <Input type="text" placeholder="Texto" name="graduateProfile" /> */}</Col>
                           </Grid>
                        </Col>
                     </FormPage>

                     {/* Segúnda página */}
                     <FormPage className={currentPage === 2 ? "isVisible" : ""}>
                        <Col>
                           <Col large={12}>
                              <Grid>
                                 <Col large={6} className="imgs">
                                    <Label>Imágen Desktop:</Label>
                                    <EditableImg editable={true} label="Medidas aprox: 394px X 317px" name="pathImageDesktop" />
                                 </Col>
                                 <Col large={6} className="imgs">
                                    <Label>Imágen Mobile</Label>
                                    <EditableImg editable={true} label="Medidas aprox: 394px X 317px" name="pathImageMobile" />
                                 </Col>
                              </Grid>
                           </Col>
                        </Col>
                        <Grid className="maxMargin">
                           <Col large={12}>
                              <Grid>
                                 <Col large={12}>
                                    <Label>Descripción corta del curso:</Label>
                                 </Col>
                                 <Col large={12}>
                                    <Input type="text" placeholder="Texto" name="shortDescription" />
                                 </Col>
                              </Grid>
                           </Col>
                           <Col large={12}>
                              <Grid>
                                 <Col large={12}>
                                    <Label>Descripción amplia del curso:</Label>
                                 </Col>
                                 <Col large={12}>
                                    <Input type="text" placeholder="Texto" name="longDescription" as="textarea" />
                                 </Col>
                              </Grid>
                           </Col>
                        </Grid>
                     </FormPage>

                     <Grid className="maxMargin">
                        <Col large={2}>
                           <AppButton
                              as="div"
                              className={`buttonAction disabled`}
                              onClick={() => {
                                 setPage(currentPage === 1 ? 2 : 1);
                              }}
                           >
                              <span>{currentPage === 1 ? "Continuar" : "Regresar"}</span>
                           </AppButton>
                        </Col>
                        {currentPage === 2 && (
                           <Col large={2} offsetL={8}>
                              <AppButton className="buttonAction">
                                 <span>Guardar</span>
                              </AppButton>
                           </Col>
                        )}
                     </Grid>
                  </form>
               </DivModal>
               <AppLoader isVisible={isSaving} />
            </>
         </Modal>
      </>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   textarea {
      font-family: Montserrat;
      resize: none;
   }
   & .maxMargin {
      margin-top: 1em;
   }
   & .imgs {
      & .row {
         width: 100%;
      }
   }

   & .buttonAction {
      text-align: center;
      height: 43px;
      box-sizing: border-box;
      user-select: none;

      &.disabled {
         pointer-events: none;
         color: grey;
         opacity: 0.5;
      }

      & span {
         font-size: 1.1em;
      }
   }
`;

const LineGrid = styled(Grid)`
   align-items: center;
`;

const FormPage = styled.div`
   width: 0;
   height: 0;
   overflow: hidden;

   &.isVisible {
      width: 100%;
      height: auto;
      overflow: visible;
   }
`;
